import PropTypes from "prop-types"
import UnifiedSearch from "modules/unified-search"
import EmptySearch from "components/compare-search/empty"
import { RECENT_INSTRUMENT_SEARCH_TYPES } from "resources/instruments"
import "./style.scss"

function CompareSearch({ account, modelId, resourceType, resourceId, itemsActions, close, disableSearchResult }) {
  return (
    <div className="experiments-settings-search">
      <UnifiedSearch
        disablePortal
        autoFocus
        account={account}
        modelId={modelId}
        searchType={RECENT_INSTRUMENT_SEARCH_TYPES.EXPERIMENT}
        compositeAssetType={resourceType}
        compositeAssetId={resourceId}
        itemsActions={itemsActions}
        onSelect={close}
        emptyContent={<EmptySearch />}
        disableResult={disableSearchResult}
        hiddenTypes={["researchTopics", "currencies"]}
      />
    </div>
  )
}

CompareSearch.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  resourceId: PropTypes.string,
  resourceType: PropTypes.string,
  itemsActions: PropTypes.object.isRequired,
  close: PropTypes.func,
  disableSearchResult: PropTypes.func.isRequired,
}

export default CompareSearch
